import React from "react";
import {
  Box,
  Tabs,
  Tab,
  Button,
  Stack,
  Grid,
  Select,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import TabPanel from "../../../components/TabPanel";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { billRelationshipContactTable } from "../../../config/grid-column-defs";
import { getRelationshipContactDetails } from "../../../api/transaction-type";

import { useParams } from "react-router-dom";
 

export default function CashSaleRelationship() {
  /*----------------Tabs-----------------*/
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  
  async function getTransactionRelationShipData() {
    // setLoading(true);
    try {
      const { data } = await getRelationshipContactDetails(user.token, {
        id: params.docNo,
      });
      // setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  return (
    <Box className="viewDetilsBox">
      <Tabs
        value={tabIndexRelationship}
        onChange={(e, nv) => {
          setTabIndexRelationship(nv);
        }}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className="tabs-sub-bkg"
      >
        <Tab label="Contacts" />
      </Tabs>
      <TabPanel value={tabIndexRelationship} index={0}>
        <Box>
        <Box className="viewDetilsBox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">CONTACT</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="CONTACT"
                  >
                    <MenuItem value="list">List</MenuItem>
                    <MenuItem value="search">Search</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={3} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">ROLE</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="ROLE"
                  >
                    <MenuItem value="alternatecontact">Alternate Contact</MenuItem>
                    <MenuItem value="consultant">Consultant</MenuItem>
                    <MenuItem value="decisionmaker">Decision Maker</MenuItem>
                    <MenuItem value="ordercreator">Order Creator</MenuItem>
                    <MenuItem value="primarycontact">Primary Contact</MenuItem>
                    <MenuItem value="licensenotification">License Notification</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={3} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="default">Default</MenuItem>
                    <MenuItem value="phone">Phone</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          </Box>
          <Box
            sx={{
              backgroundColor: "#bbd9e8",
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New Contact</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Update Primary</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={getTransactionRelationShipData}
            columns={billRelationshipContactTable}
            refreshCounter={0}
          />
        </Box>
      </TabPanel>
    </Box>
  );
}
